import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface InstallNotesInputProps {
  onInstallNotesChange: (value: string) => void;
  installNotesValue: string;
  isEnabled: boolean;
}

export const InstallNotesInput: React.FC<InstallNotesInputProps> = ({
  onInstallNotesChange,
  installNotesValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="Install Notes"
      label="Enter Install Notes:"
      placeholder="Enter installation notes..."
      value={installNotesValue}
      onChange={onInstallNotesChange}
      isEnabled={isEnabled}
      isTextArea={true}
    />
  );
};